import { type AiModelConfig } from '../api/aimodels/useAiModels';
import { useChatSidebarStore } from './useChatSidebarStore';
import { useModelSelectionStore } from './useModelSelectionStore';

export type SelectAgentModelParams = {
  model: AiModelConfig;
  resourceId: string;
};

/**
 * Turns auto off, selects `model` for `resourceId`, and opens the chat sidebar so its composer
 * shows the new model. The model picker menu stays closed.
 */
export const selectAgentModel = ({ model, resourceId }: SelectAgentModelParams) => {
  const { setIsAuto, setSelectedModel } = useModelSelectionStore.getState();

  setIsAuto(resourceId, false);
  setSelectedModel(resourceId, model);
  useChatSidebarStore.getState().setOpen(true);
};
